import React, { useEffect, useState } from "react";
import { quiz as quizData } from "./data";
import "react-notifications/lib/notifications.css";
import {
	NotificationContainer,
	NotificationManager,
} from "react-notifications";
import Formsiswa from "./Formsiswa";
import fire from "../../../../../helpers/db";
const Kuis = () => {
	const db = fire.firestore();
	const [siswa, setSiswa] = useState("");
	const [hasil, setHasil] = useState(false);
	const [currentIndex, setCurrentIndex] = useState(0);
	const [quiz, setQuiz] = useState(quizData);
	const [score, setScore] = useState({
		correct: 0,
		false: 0,
	});

	const userState = () => {
		const data = localStorage.getItem("user");
		const userobject = data !== null ? JSON.parse(data) : null;
		setSiswa(userobject);
	};

	useEffect(() => {
		userState();
	}, []);

	const { pertanyaan, options } = quiz[currentIndex];

	const nextQuestion = () => {
		if (quiz.length - 1 === currentIndex) return;
		setCurrentIndex(currentIndex + 1);
	};
	const previousQuestion = () => {
		if (currentIndex === 0) return;
		setCurrentIndex(currentIndex - 1);
	};

	const selectOption = (indexSelected, indexSelectedOptions) => {
		setQuiz(
			quiz.map((item, index) =>
				index === indexSelected
					? {
							...item,
							selected: true,
							options: options.map((item, index) =>
								index === indexSelectedOptions
									? { ...item, selected: true }
									: { ...item, selected: false }
							),
					  }
					: item
			)
		);
	};
	const checkScore = () => {
		const questionAnswered = quiz.filter((item) => item.selected);
		let testAnswer = [];
		questionAnswered.forEach((item) =>
			item.options.forEach((data) => {
				if (data.selected) testAnswer.push(data);
			})
		);
		
		const questionCorrect = questionAnswered.filter((item) =>
			item.options.find(
				(option) => option.correct && option.selected === option.correct
			)
		);
		if (testAnswer.length < 10) {
			NotificationManager.error("Kamu harus mengisi semua jawaban", "", 1500);
		} else {
			setHasil(true);
			setScore({
				correct: questionCorrect.length,
				false: quiz.length - questionCorrect.length,
			});
			db.collection("kuis2").add({
				nama: siswa.nama,
				sekolah: siswa.sekolah,
				nilai: questionCorrect.length * 10,
				picked: testAnswer,
			});
		}
	};
	return (
		<div>
			{siswa !== null ? (
				<div className="container">
					{hasil ? (
						<>
						<div className="row">
				<div className="col">
					<div
						className="card mt-2 border-success"
						style={{ borderRadius: "20px" }}
					>
						<div
							style={{ backgroundColor: "#40bf80", borderRadius: "20px" }}
							className="card-header"
						>
							<h6 className="text-white text-center">Skor Kuis 2</h6>
						</div>
						<div className="card-body">
						<div className="text-center h1">{score.correct * 10}</div>
							<ol>
								<li>Nama Siswa : {siswa.nama}</li>
								<li>Kelas Siswa : {siswa.sekolah}</li>
								
							</ol>
						</div>
						<div className="card-footer">
						{score.correct < 7 ? (<><div className="text-center h4 mt-1">Nilai Kamu di bawah KKM !!, Kamu harus lebih giat lagi ya &#128170;</div></>) 
					: 
					(<>
					<div className="text-center h4 mt-1">Nilai Kamu di atas KKM !! , Selamat ya &#128077;</div>
						<div className="text-center mt-2">
							<h6>Silahkan tutup halaman ini, kemudian lanjut ke sub bab berikutnya  &#128076;</h6>
							<button className="btn btn-success" onClick={() => { window.location.href ="/materi/nilai";}}>Klik di sini</button>
						</div>
					</>)
					}
						</div>
					</div>
				</div>
			</div>
							
						</>
					) : (
						<div className="container">
								<NotificationContainer/>
							<div className="row align-items-start">
								<div className="col"></div>
								<div className="col">
									<div
										className="card border-danger mt-2"
										style={{ width: "20rem" }}
									>
										<div className="card-body ">
											<div className="text-center">
												<h5 style={{ color: "orangered" }}>Keterangan</h5>
											</div>
											<div
												className=""
												style={{
													display: "flex",
													justifyContent: "space-between",
												}}
											>
												<div>
													<div
														style={{
															borderRadius: "10px",
															width: "50px",
															height: "50px",
															backgroundColor: "#00e64d",
														}}
													></div>
													<p style={{ color: "green" }}>Sudah dijawab</p>
												</div>
												<div>
													<div
														style={{
															borderRadius: "10px",
															width: "50px",
															height: "50px",
															backgroundColor: "orange",
														}}
													></div>
													<p style={{ color: "orange" }}>Soal sekarang</p>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col"></div>
							</div>
							<div className="card shadow  bg-body rounded mt-2">
								<div className="card-body" style={{ display: "flex",padding:"10",flexWrap:'wrap' }}>
									{quiz.map((item, index) => (
										<div
											className="border"
											style={{
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
												height: 40,
												width: 40,
												marginRight: 10,
												borderRadius: 8,
												backgroundColor:
													index === currentIndex
														? "orange"
														: item?.selected
														? "#00e64d"
														: "transparent",
												fontWeight: "bold",
												color: item?.selected ? "white" : "black",
											}}
											onClick={() => setCurrentIndex(index)}
										>
											{index + 1}
										</div>
									))}
								</div>
							</div>

							<div className="card shadow  bg-body rounded mt-2">
								<div className="card-header">
									<div
										style={{
											position: "relative",
											display: "flex",
										}}
									>
										<p style={{ textAlign: "center", lineHeight: "35px" }}>
											{pertanyaan}
										</p>
									</div>
								</div>

								<div className="card-body">
									{options.map((item, index) => (
										<div
											style={{
												display: "flex",
												fontSize: 18,
											}}
											key={index}
										>
											<div
												style={{
													height: 20,
													width: 20,
													borderRadius: 100,
													backgroundColor: item?.selected
														? "limegreen"
														: "lightgrey",
													cursor: "pointer",
													marginRight: 10,
													display: "flex",
													justifyContent: "center",
												}}
												onClick={() => selectOption(currentIndex, index)}
											/>
											{item.title}
										</div>
									))}
								</div>
							</div>
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
									paddingTop: 15,
									marginBottom: "1.5rem",
								}}
							>
								<button
									className="btn btn-success col-sm-2"
									onClick={() => previousQuestion()}
									disabled={currentIndex === 0 ? true : false}
								>
									Previous
								</button>

								{quiz.length - 1 === currentIndex ? (
									<button
										className="btn btn-warning col-sm-2"
										onClick={() => checkScore()}
									>
										{" "}
										Finish{" "}
									</button>
								) : (
									<button
										className="btn btn-success col-sm-2"
										onClick={() => nextQuestion()}
									>
										Next{" "}
									</button>
								)}
							</div>
						</div>
					)}
				</div>
			) : (
				<Formsiswa palakao={(siswa) => setSiswa(siswa)} />
			)}

			{/* div akhir */}
		</div>
	);
};

export default Kuis;
